import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';
import { Modal, Badge } from 'antd';
import { resolve } from 'inversify-react';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { RuleOperationsService, IStackTraceMessage } from 'src/app/rules/rules/rule-services';
import { ZuluIcon } from 'src/app/shared/icon';

@observer
export class RulesListView extends React.Component<RuleListViewProps, any> {
	constructor(props: any) {
		super(props);

		this.openedePreview = false;
		this.message = '';
	}


	@observable
	message: string;

	@observable
	openedePreview: boolean;

	@resolve
	rulesService: RuleOperationsService


	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'id',
				title: 'Id',
				dataIndex: 'id'
			},

			{
				key: 'name',
				title: 'Name',
				dataIndex: 'name',
				render: (text, record: RuleSummary) => <Link to={`/rules/rules/${record.id}`}>{text}</Link>,
			},
			{
				key: 'mode',
				title: 'Execution Mode',
				dataIndex: 'modeText'
			},
			{
				key: 'description',
				title: 'Description',
				dataIndex: 'description'
			},
			{
				key: 'lastExecutionMessage',
				title: 'Last Status',
				dataIndex: 'lastExecutionMessage',
				width: '100px',
				render: (text, record, index) => {
					return <div>
						{
							(text != null && text.trim() !== '') ? <div style={{ cursor: 'pointer' }} onClick={() => {
								this.openedePreview = true;
								this.message = text;
							}} ><Badge status='error' text='Error' /></div> :

								(record.isIdle ? <Badge status='default' text='Idle'  /> :
									<div style={{ cursor: 'pointer' }} ><Badge status='success' text='Succes' /></div>)}
					</div>;

				}
			},

			{
				key: 'data',
				title: 'Payload',
				dataIndex: '',
				render: (text, record: RuleSummary, index) => {

					if (record.mode == 0)
						return record.eventTypeFullName;
					if (record.mode == 1)
						return record.executionDateText;
					if (record.mode == 2)
						return record.executionTimeSpan;
				}
			},
			{
				key: 'isActive',
				title: 'Active',
				dataIndex: 'isActive',
				render: (text, record, index) => {
					return <BooleanView label=''
						mode='edit' value={record.isActive} onChanged={e => {

							this.props.setBusy(true);


							this.rulesService.toggleRuleActivation(record.id, !record.isActive).then(
								result => {
									this.props.onReload();
								}
							).catch(reason => {
								this.props.onReload();
							});

							record.isActive = !record.isActive;
						}} />
						;
				}
			},
			{
				key: 'dateText',
				title: 'Last execution time',
				dataIndex: 'dateText'
			},
			{
				key: 'stackTrace',
				title: '',
				dataIndex: 'modeText',
				render: (text, record, index) => {
					if (record.isIdle)
						return null;

					return <ZuluIcon style={{ margin: '5px', cursor: 'pointer' }} title="Stack trace" type='icon-bug' onClick={() => this.props.gotoStackTrace(record.id)} />
				}
			}
		];

		return (
			<div className="window window-normal">

				<div className="panel">
					<Modal
						visible={this.openedePreview}
						onOk={() => this.openedePreview = false}
						onCancel={() => this.openedePreview = false}

					>
						<h2>Last Execution Message</h2>
						<p style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>{this.message}</p>
					</Modal>

					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}

					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/list/rules-list.view.tsx